<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          Exportações de Marcações
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <label>Período (início)</label>
            <input
              v-model="filters.start_date"
              type="date"
              class="form-control"
            >
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label>Período (fim)</label>
            <input
              v-model="filters.end_date"
              type="date"
              class="form-control"
            >
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label>Departamento(s)</label>
            <v-select
              v-model="filters.department_ids"
              :options="filteredDepartments"
              label="title"
              :reduce="d => d.id"
              placeholder="Todos"
              multiple
              clearable
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label>Cargo(s)</label>
            <v-select
              v-model="filters.role_ids"
              :options="filteredRoles"
              label="title"
              :reduce="r => r.id"
              placeholder="Todos"
              multiple
              clearable
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <label>Atribuição(ões)</label>
            <v-select
              v-model="filters.alocation_ids"
              :options="alocations"
              label="name"
              :reduce="a => a.id"
              placeholder="Todas"
              multiple
              clearable
            />
          </div>
          <div class="col-12 col-md-8 mb-3">
            <label>Usuários (opcional)</label>
            <v-select
              v-model="filters.user_ids"
              :options="filteredUsers"
              label="name"
              :reduce="u => u.id"
              placeholder="Selecione usuários"
              multiple
            />
          </div>
          <div class="col-12 text-right mt-2">
            <button
              class="btn btn-primary mr-2"
              @click="preview"
            >
              Visualizar
            </button>
            <button
              class="btn btn-success"
              :disabled="exporting"
              @click="exportAll()"
            >
              <i
                v-if="exporting"
                class="fas fa-spinner fa-spin mr-1"
              />
              Exportar CSV
            </button>
            <button
              class="btn btn-info ml-2"
              :disabled="exporting"
              @click="exportAll('xlsx')"
            >
              <i
                v-if="exporting"
                class="fas fa-file-excel mr-1"
              />
              Exportar XLSX
            </button>
          </div>
        </div>

        <div
          v-if="previewRows.length"
          class="mt-4"
        >
          <h5>Preview (primeiras 20 linhas)</h5>
          <div class="table-responsive preview-table-container">
            <table class="table table-sm table-striped preview-table">
              <thead>
                <tr>
                  <th>Usuário</th>
                  <th>Departamento</th>
                  <th>Cargo</th>
                  <th>Alocação</th>
                  <th
                    v-for="(label, idx) in previewDates"
                    :key="label"
                    :title="previewFullDates[idx]"
                  >
                    {{ label }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in displayPreviewRows"
                  :key="row.user_id"
                >
                  <td>{{ row.name }}</td>
                  <td>{{ row.department }}</td>
                  <td>{{ row.role }}</td>
                  <td>{{ row.alocation || '-' }}</td>
                  <td
                    v-for="(label, idx) in previewDates"
                    :key="label"
                  >
                    <div class="small text-muted">
                      <span v-if="row.punches_by_date && row.punches_by_date[previewFullDates[idx]] && row.punches_by_date[previewFullDates[idx]].length">
                        {{ row.punches_by_date[previewFullDates[idx]].join(' • ') }}
                      </span>
                      <span
                        v-else
                        class="text-muted"
                      >-</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        start_date: moment().startOf('month').format('YYYY-MM-DD'),
        end_date: moment().endOf('month').format('YYYY-MM-DD'),
        department_ids: [],
        role_ids: [],
        alocation_ids: [],
        user_ids: [],
      },
      departments: [],
      roles: [],
      alocations: [],
      users: [],
      exporting: false,
      previewLoading: false,
      previewRows: [],
      previewDates: [],
      previewFullDates: [],
      previewFilter: '',
      lastPreviewRequestId: 0,
    }
  },
  computed: {
    usersBySelectedAlocation() {
      const selectedAlocationIds = new Set((this.filters.alocation_ids || []).map(Number))
      if (!selectedAlocationIds.size) return this.users || []

      return (this.users || []).filter(user => {
        const alocations = Array.isArray(user.alocations) ? user.alocations : []
        return alocations.some(alocation => selectedAlocationIds.has(Number(alocation.id)))
      })
    },
    filteredDepartments() {
      const users = this.usersBySelectedAlocation
      const validDepartmentIds = new Set(users.map(user => Number(user.department_id)).filter(Boolean))
      return (this.departments || []).filter(department => validDepartmentIds.has(Number(department.id)))
    },
    filteredRoles() {
      const selectedDepartments = new Set((this.filters.department_ids || []).map(Number))
      const users = this.usersBySelectedAlocation.filter(user => {
        if (!selectedDepartments.size) return true
        return selectedDepartments.has(Number(user.department_id))
      })

      const validRoleIds = new Set(users.map(user => Number(user.role_id)).filter(Boolean))
      return (this.roles || []).filter(role => validRoleIds.has(Number(role.id)))
    },
    filteredUsers() {
      const selectedDepartments = new Set((this.filters.department_ids || []).map(Number))
      const selectedRoles = new Set((this.filters.role_ids || []).map(Number))

      return this.usersBySelectedAlocation.filter(user => {
        const matchesDepartment = !selectedDepartments.size || selectedDepartments.has(Number(user.department_id))
        const matchesRole = !selectedRoles.size || selectedRoles.has(Number(user.role_id))
        return matchesDepartment && matchesRole
      })
    },
    displayPreviewRows() {
      let rows = this.previewRows || []
      if (this.previewFilter && this.previewFilter.trim()) {
        const q = this.previewFilter.toLowerCase()
        rows = rows.filter(r => {
          if ((r.name && r.name.toLowerCase().includes(q))
              || (r.department && r.department.toLowerCase().includes(q))
              || (r.role && r.role.toLowerCase().includes(q))) return true
          for (const d of (this.previewFullDates || [])) {
            const arr = (r.punches_by_date && r.punches_by_date[d]) ? r.punches_by_date[d].join(' • ') : ''
            if (arr && arr.toLowerCase().includes(q)) return true
          }
          return false
        })
      }
      return rows.slice(0, 20)
    },
  },
  watch: {
    'filters.start_date': function () {
      this.clearPreviewState()
    },
    'filters.end_date': function () {
      this.clearPreviewState()
    },
    'filters.department_ids': {
      handler() {
        this.sanitizeSelectedFilters()
        this.clearPreviewState()
      },
      deep: true,
    },
    'filters.role_ids': {
      handler() {
        this.sanitizeSelectedFilters()
        this.clearPreviewState()
      },
      deep: true,
    },
    'filters.alocation_ids': {
      handler() {
        this.sanitizeSelectedFilters()
        this.clearPreviewState()
      },
      deep: true,
    },
    'filters.user_ids': {
      handler() {
        this.sanitizeSelectedFilters()
        this.clearPreviewState()
      },
      deep: true,
    },
  },
  mounted() {
    this.loadOptions()
  },
  methods: {
    normalizeList(response) {
      return Array.isArray(response?.data?.data)
        ? response.data.data
        : Array.isArray(response?.data)
          ? response.data
          : []
    },
    sortedByLabel(items, key) {
      return (items || []).slice().sort((a, b) => {
        const first = String(a?.[key] || '').toLowerCase()
        const second = String(b?.[key] || '').toLowerCase()
        return first.localeCompare(second)
      })
    },
    clearPreviewState() {
      this.previewRows = []
      this.previewDates = []
      this.previewFullDates = []
    },
    arraysEqualAsSet(first, second) {
      const normalizedFirst = Array.from(new Set((first || []).map(Number))).sort((a, b) => a - b)
      const normalizedSecond = Array.from(new Set((second || []).map(Number))).sort((a, b) => a - b)
      if (normalizedFirst.length !== normalizedSecond.length) return false
      return normalizedFirst.every((value, index) => value === normalizedSecond[index])
    },
    setArrayIfChanged(field, nextValues) {
      const current = this.filters[field] || []
      const normalized = Array.from(new Set((nextValues || []).map(Number)))
      if (!this.arraysEqualAsSet(current, normalized)) {
        this.filters[field] = normalized
      }
    },
    sanitizeSelectedFilters() {
      const availableDepartmentIds = new Set((this.filteredDepartments || []).map(d => Number(d.id)))
      const availableRoleIds = new Set((this.filteredRoles || []).map(r => Number(r.id)))
      const availableUserIds = new Set((this.filteredUsers || []).map(u => Number(u.id)))

      this.setArrayIfChanged('department_ids', (this.filters.department_ids || []).filter(id => availableDepartmentIds.has(Number(id))))
      this.setArrayIfChanged('role_ids', (this.filters.role_ids || []).filter(id => availableRoleIds.has(Number(id))))
      this.setArrayIfChanged('user_ids', (this.filters.user_ids || []).filter(id => availableUserIds.has(Number(id))))
    },
    buildParams() {
      const params = { ...this.filters }
      if (Array.isArray(params.user_ids)) params.user_ids = params.user_ids.join(',')
      if (Array.isArray(params.department_ids)) params.department_id = params.department_ids.join(',')
      if (Array.isArray(params.role_ids)) params.role_id = params.role_ids.join(',')
      if (Array.isArray(params.alocation_ids)) params.alocation_id = params.alocation_ids.join(',')
      delete params.department_ids
      delete params.role_ids
      delete params.alocation_ids
      return params
    },
    loadOptions() {
      const apiBase = this.$store.state.api
      Promise.all([
        axios.get(`${apiBase}departments`),
        axios.get(`${apiBase}roles`),
        axios.get(`${apiBase}users`, { params: { paginated: false, with: ['department', 'role', 'alocations'], limit: 9999 } }),
        axios.get(`${apiBase}alocations/`),
      ])
        .then(([departmentsRes, rolesRes, usersRes, alocationsRes]) => {
          this.departments = this.sortedByLabel(this.normalizeList(departmentsRes), 'title')
          this.roles = this.sortedByLabel(this.normalizeList(rolesRes), 'title')

          const loadedUsers = this.normalizeList(usersRes)
            .filter(user => !user.deleted_at && !user.demission_date)
            .map(user => ({
              ...user,
              alocations: Array.isArray(user.alocations) ? user.alocations : [],
            }))

          this.users = this.sortedByLabel(loadedUsers, 'name')
          this.alocations = this.sortedByLabel(this.normalizeList(alocationsRes), 'name')
          this.sanitizeSelectedFilters()
        })
        .catch(() => {
          this.$message('Erro', 'Não foi possível carregar filtros de exportação.', 'error')
        })
    },
    validatePeriod() {
      if (!this.filters.start_date || !this.filters.end_date) return false
      const s = moment(this.filters.start_date)
      const e = moment(this.filters.end_date)
      if (!s.isValid() || !e.isValid()) return false
      if (s.isAfter(e)) return false
      if (e.diff(s, 'days') > 31) {
        this.$message('Aviso', 'Período máximo 31 dias.', 'warning')
        return false
      }
      return true
    },
    preview() {
      if (!this.validatePeriod()) return
      this.clearPreviewState()
      this.previewLoading = true
      const requestId = ++this.lastPreviewRequestId
      const params = this.buildParams()
      const api = `${this.$store.state.api}checks/export_preview`
      axios.get(api, { params }).then(res => {
        if (requestId !== this.lastPreviewRequestId) return
        const data = res.data || {}
        this.previewRows = (data.rows || [])
        this.previewFullDates = data.dates || []
        this.previewDates = data.date_labels && data.date_labels.length ? data.date_labels : this.previewFullDates
      }).catch(err => {
        this.$message('Erro', err.response && err.response.data ? err.response.data : 'Erro no preview', 'error')
      }).finally(() => {
        if (requestId === this.lastPreviewRequestId) {
          this.previewLoading = false
        }
      })
    },
    exportAll(format) {
      if (!this.validatePeriod()) return
      this.exporting = true
      const params = this.buildParams()
      if (format) params.format = format
      const api = `${this.$store.state.api}checks/export`
      axios.get(api, { params, responseType: 'blob' })
        .then(response => {
          const disposition = response.headers['content-disposition'] || ''
          let filename = `checks_export.${params.format === 'xlsx' ? 'xlsx' : 'csv'}`
          const match = disposition.match(/filename="?([^";]+)"?/)
          if (match) filename = match[1]
          let mime = 'text/csv;charset=utf-8;'
          if (params.format === 'xlsx') {
            mime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
          const blob = new Blob([response.data], { type: mime })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch(err => {
          this.$message('Erro', err.response && err.response.data ? err.response.data : 'Erro ao exportar', 'error')
        })
        .finally(() => {
          this.exporting = false
        })
    },
  },
}
</script>

<style scoped>
.table-responsive { max-height: 400px; overflow-y: auto; }
.preview-table-container { overflow-x: auto; }
.preview-table th { white-space: nowrap; font-size: 12px; }
.preview-table td { white-space: nowrap; font-size: 13px; }
.preview-table td .small { font-size: 12px; }
</style>
